<template>
 
   <v-layout align-start>
    <v-flex>
        <v-toolbar text color="white">
            <v-toolbar-title>Indicadores</v-toolbar-title>
                <v-divider
                    class="mx-2"
                    inset
                    vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda" single-line hide-details></v-text-field>
                <v-spacer></v-spacer>
                <v-dialog v-model="dialog" max-width="800px">
                <v-spacer></v-spacer>

                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-3" v-on="on">Nuevo Indicador</v-btn>
                    </template>

                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-row>
                                        <v-col cols="12" sm="4" md="3">
                                            <v-text-field v-model="codigo_indicador" label="Codigo Indicador"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="4" md="4">
                                            <v-text-field v-model="periodo" label="Codigo Periodo"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="nombre_indicador" label="Nombre Indicador"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="12">
                                            <v-text-field v-model="formula" label="Formula (utilice las variables (A, B, C, D, E, F) para armar la formula)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable1" label="Nombre Variable (A)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable1" label="Valor Variable (A)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable2" label="Nombre Variable (B)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable2" label="Valor Variable (B)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable3" label="Nombre Variable (C)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable3" label="Valor Variable (C)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable4" label="Nombre Variable (D)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable4" label="Valor Variable (D)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable5" label="Nombre Variable (E)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable5" label="Valor Variable (E)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="6">
                                            <v-text-field v-model="nombre_variable6" label="Nombre Variable (F)"></v-text-field>
                                        </v-col>
                                            <v-col cols="12" sm="6" md="4">
                                            <v-text-field v-model="variable6" label="Valor Variable (F)"></v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" md="8">
                                            <v-select v-model="codigo_responsable_indicador"
                                                :items="nombre_responsable_indicador"  label="Nombre Responsable">
                                            </v-select>
                                        </v-col>                                        
                                    </v-row>
                                    <v-flex xs12 sm12 md12 v-show="valida">
                                        <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                                        </div>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click.native="close">Cancelar</v-btn>
                            <v-btn color="red darken-1" text @click.native="guardar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>cd
                </v-dialog>
 
                 <v-dialog v-model="adModal" max-width="290">
                    <v-card>
                        <v-card-title class="headline" v-if="adAccion==1">¿Activar Item? </v-card-title>
                        <v-card-title class="headline" v-if="adAccion==2">¿Desactivar Item? </v-card-title>
                    <v-card-text>
                        Estas a punto del
                        <span v-if="adAccion==1">Activar </span>
                        <span v-if="adAccion==2">Desactivar </span>
                        el item {{ adIdIndicador}}    
                    </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="green darken-1" text="text" @click="activarDesactivarCerrar">
                                    Cancelar
                                </v-btn>
                                <v-btn v-if="adAccion==1" color="orange darken-4" text="text" @click="activar">
                                    Activar
                                </v-btn>
                                <v-btn v-if="adAccion==2" color="orange darken-4" text="text" @click="desactivar">
                                    Desactivar
                                </v-btn>
                            </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>

   <v-data-table
        :headers="headers"
        :items="indicadores"
        :search="search"
        class="elevation-1"
    >     
                <template v-slot:item.action="{ item }">
                    <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                    >
                        mdi-grease-pencil
                    </v-icon>
                    <template v-if="item.estado_indicador">
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(2,item)"
                        >
                            mdi-block-helper
                        </v-icon>
                    </template>
                    <template v-else>
                        <v-icon
                            small
                            @click="activarDesactivarMostrar(1,item)"
                        >
                            mdi-check-all
                        </v-icon>
                    </template>
                </template>

                <template slot="items" slot-scope="props">
                    <td>{{ props.item.codigo_indicador }}</td>
                    <td>{{ props.item.periodo }}</td>
                    <td>{{ props.item.nombre_indicador }}</td>
                    <td>{{ props.item.formula }}</td>
                    <td>{{ props.item.nombre_variable1 }}</td>
                    <td>{{ props.item.variable1 }}</td>
                    <td>{{ props.item.nombre_variable2 }}</td>
                    <td>{{ props.item.variable2 }}</td>
                    <td>{{ props.item.nombre_variable3 }}</td>
                    <td>{{ props.item.variable3 }}</td>
                    <td>{{ props.item.nombre_variable4 }}</td> 
                    <td>{{ props.item.variable4 }}</td>
                    <td>{{ props.item.nombre_variable5 }}</td>
                    <td>{{ props.item.variable5 }}</td>
                    <td>{{ props.item.nombre_variable6 }}</td>
                    <td>{{ props.item.variable6 }}</td>                       
                    <td>{{ props.item.codigo_responsable_indicador }}</td>
                    <td>{{ props.item.nombre_responsable_indicador }}</td>
                    <td>
                        <div v-if="props.item.estado_indicador">
                            <span class="blue--text">Activo</span>
                        </div>
                        <div v-else>
                            <span class="red--text">Inactivo</span>
                        </div>
                    </td>
                </template>

                <template slot="no-data">
                <v-btn color="primary" @click="listar">Resetear</v-btn>
                </template>
    </v-data-table>

        </v-flex>
    </v-layout>

</template>

<script>
import axios from 'axios'

export default {
    data(){
        return{
                indicadores:[],                
                dialog: false,
                headers: [
                    { text: 'Opciones', value: 'action', sortable: false},
                    { text: 'Cod. Indicador', value: 'codigo_indicador' },
                    { text: 'Periodo', value: 'periodo' },
                    { text: 'Nombre Indicador', value: 'nombre_indicador' , sortable: false},                    
                    { text: 'Formula', value: 'formula' },
                    { text: 'Variable A', value: 'nombre_variable1' , sortable: false},
                    { text: 'Valor Var. A', value: 'variable1', sortabl: false },
                    { text: 'Variable B', value: 'nombre_variable2', sortable: false },
                    { text: 'Valor Var. B', value: 'variable2', sortabl: false },
                    { text: 'Variable C', value: 'nombre_variable3', sortable: false },
                    { text: 'Valor Var. C', value: 'variable3', sortabl: false },
                    { text: 'Variable D', value: 'nombre_variable4', sortable: false },
                    { text: 'Valor Var. D', value: 'variable4', sortabl: false },
                    { text: 'Variable E', value: 'nombre_variable5', sortable: false },
                    { text: 'Valor Var. E', value: 'variable5', sortabl: false },
                    { text: 'Variable F', value: 'nombre_variable6', sortable: false },
                    { text: 'Valor Var. F', value: 'variable6', sortable: false },
                    { text: 'Codigo Responsable', value: 'codigo_responsable_indicador' , sortable: false},
                    { text: 'Nombre Responsable', value: 'nombre_responsable_indicador' },
                    { text: 'Estado Indicador', value: 'estado_indicador' , sortable: false}
                ],
                search: '',
                editedIndex: -1,
                codigo_indicador: '',
                periodo: '',
                nombre_indicador:'',
                formula: '',
                nombre_variable1: '',
                variable1: '',
                nombre_variable2: '',
                variable2: '',
                nombre_variable3: '',
                variable3: '',
                nombre_variable4: '',
                variable4: '',
                nombre_variable5: '',
                variable5: '',
                nombre_variable6: '',
                variable6: '',
                codigo_responsable_indicador: '',
                nombre_responsable_indicador:[                    
                ] ,  
                verNuevo:0,              
                valida: 0,
                validaMensaje:[],
                adModal: 0,
                adAccion: 0,
                adIdIndicador:'',
                adNombre:''
        }
    },
        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Nuevo indicador' : 'Actualizar indicador'
            }
        },


    watch: {
        dialog (val) {
        val || this.close()
        },
    },

    created () {
        this.listar();
        this.select();
    },
    methods:
    {
       
        listar(){
            let me=this;
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};            
			axios.get('api/Hechos_Indicador/Listar',configuracion).then(function(response){
				//console.log(response);
				me.indicadores=response.data;
			}).catch(function(error){
				console.log(error);   
			});
		},
        select(){
            let me=this;
            var responsableindicadorArray= [];
			axios.get('api/Responsables_Indicadores/Select').then(function(response){
                //console.log(response);
                responsableindicadorArray=response.data;
                responsableindicadorArray.map(function(x){
                    me.nombre_responsable_indicador.push({text: x.nombre_responsable_indicador, value:x.codigo_responsable_indicador});
                });
			}).catch(function(error){
				console.log(error);   
			});
		},

		editItem (item) {
 			this.IdIndicador=item.idIndicador;
			this.codigo_indicador=item.codigo_indicador;
			this.adCodigo_Indicador=item.codigo_indicador;
            this.periodo=item.periodo;
            this.nombre_indicador= item.nombre_indicador;
			this.formula=item.formula;
			this.nombre_variable1=item.nombre_variable1;
			this.variable1=item.variable1;
			this.nombre_variable2=item.nombre_variable2;
			this.variable2=item.variable2;
			this.nombre_variable3=item.nombre_variable3;
			this.variable3=item.variable3;
			this.nombre_variable4=item.nombre_variable4;
			this.variable4=item.variable4;
			this.nombre_variable5=item.nombre_variable5;
			this.variable5=item.variable5;
			this.nombre_variable6=item.nombre_variable6;
			this.variable6=item.variable6;
			this.codigo_responsable_indicador=item.codigo_responsable_indicador;
			this.estado_indicador=item.estado_indicador;
            this.editedIndex=1;            
			this.dialog = true
		},

		close () {
            this.dialog = false;
            this.limpiar();
		},

		limpiar(){
			this.codigo_indicador="";
            this.periodo= 0;
            this.nombre_indicador= "";
			this.formula="";
			this.nombre_variable1= "";
			this.variable1=0;
			this.nombre_variable2= "";
			this.Variable2=0;
			this.nombre_variable3= "";
			this.variable3=0;
			this.nombre_variable4= "";
			this.variable4=0;
			this.nombre_variable5= "";
			this.variable5=0;
			this.nombre_variable6= "";
			this.variable6=0;
            this.codigo_responsable_indicador="";
			this.editedIndex=-1;
		},


		guardar () {
            
			if(this.validar()){
				return;
			}
			if (this.editedIndex > -1) {
				// codigo para guardar
				let me=this;
				axios.put('api/Hechos_Indicador/Actualizar',{
                    'idIndicador':me.IdIndicador,
                    'codigo_indicador': me.codigo_indicador,
					'periodo': me.periodo,
                    'nombre_indicador': me.nombre_indicador,
					'formula':me.formula,
					'nombre_variable1':me.nombre_variable1,
					'variable1':me.variable1,
					'nombre_variable2':me.nombre_variable2,
					'variable2':me.variable2,
					'nombre_variable3':me.nombre_variable3,
					'variable3':me.variable3,
					'nombre_variable4':me.nombre_variable4,
					'variable4':me.variable4,
					'nombre_variable5':me.nombre_variable5,
					'variable5':me.Variable5,
					'nombre_variable6':me.nombre_variable6,
					'variable6':me.Variable6,
					'codigo_responsable_indicador':me.codigo_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
				});

			} else {
		   //     this.desserts.push(this.editedItem)
				let me=this;
				axios.post('api/Hechos_Indicador/Crear',{
					'codigo_indicador': me.codigo_indicador,
					'periodo': me.periodo,
                    'nombre_indicador': me.nombre_indicador,
					'formula':me.formula,
					'nombre_variable1':me.nombre_variable1,
					'variable1':me.variable1,
					'nombre_variable2':me.nombre_variable2,
					'variable2':me.variable2,
					'nombre_variable3':me.nombre_variable3,
					'variable3':me.variable3,
					'nombre_variable4':me.nombre_variable4,
					'variable4':me.variable4,
					'nombre_variable5':me.nombre_variable5,
					'variable5':me.Variable5,
					'nombre_variable6':me.nombre_variable6,
					'variable6':me.Variable6,
					'codigo_responsable_indicador':me.codigo_responsable_indicador
				}).then(function(response){
					me.close();
					me.listar();
					me.limpiar();                        
				}).catch(function(error){
					console.log(error);
                });
                
			}
        },

		validar(){
			this.valida=0;
			this.validaMensaje=[];
            if(!this.periodo){
				this.validaMensaje.push("Digite un periodo");
            }            
			if(this.nombre_indicador < 3 || this.nombre_indicador > 100){
				this.validaMensaje.push("El Nombre indicador debe tener mas de 3 caracteres y menos de 100 caracteres");
            }
			if(this.formula.length < 1 || this.formula.length > 100){
				this.validaMensaje.push("La formula debe tener mas de 1 caracteres y menos de 100 caracteres");
            }
			if(!this.nombre_variable1){
				this.validaMensaje.push("Debe digitar el nombre de por lo menos una variable ");
            }
			if(!this.variable1){
				this.validaMensaje.push("Debe digitar por lo menos una variable ");
            }
		    if(this.validaMensaje.length){
				this.valida=1;
			}
		    return this.valida;
        },

        activarDesactivarMostrar(accion,item){
        this.adModal=1;
        this.adIdIndicador=item.idIndicador;
        if (accion==1){
            this.adAccion=1;
        }
        else if (accion==2){
        this.adAccion=2;
        }
        else{
        this.adModal=0;
        }
        },
        activarDesactivarCerrar(){
        this.adModal=0;
        },
        activar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Activar/'+this.adIdIndicador,{}).then(function(response){
            me.adModal=0;
            me.adAccion=0;
            me.adNombre="";
            me.adIdIndicador="";
            me.listar();                       
            }).catch(function(error){
                console.log(error);
            });
        },
        desactivar(){
            let me=this;
            axios.put('api/Hechos_Indicador/Desactivar/'+this.adIdIndicador,{}).then(function(response){
                me.adModal=0;
                me.adAccion=0;
                me.adIdIndicador="";
                me.adNombre="";
                me.listar();                       
            }).catch(function(error){
            console.log(error);
        });
            }
        }        
    }
</script>